<template>
      <div class="row mb-3">
        <div class="col-sm-12 bg-color">
          <div class="title_area">
            <h2 class="mb-0"><slot></slot></h2>
          </div>
        </div>
      </div>
</template>

<script>
export default {

  name: 'pagetitle',

  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
</style>